import "../css/app.css";

export default function Loader(props) {

    return (
        <div>
            {/* 'absolute w-1/4 top-50 p-3 text-center left-50 bg-white border border-gray-400' */}
            <div className='overlay'></div>
            <div className="loader-block">
                <div className='lds-roller'>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div className="loader-text">Loading...</div>
                <div className="loader-text">{props.message ? props.message : null}</div>
            </div>
        </div >
    );
}